import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    limpaFiltroDetalhesMetasEducacaoOrgao: [],
    aplicarFiltroDetalhesMetasEducacaoOrgao: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: '',
    mesLiquidacao: {},
    sequencia: '',
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.LIMPA_FILTRO_DETALHES_METAS_EDUCACAO_ORGAO]: limpaFiltro,
    [Types.APLICAR_FILTRO_DETALHES_METAS_EDUCACAO_ORGAO]: aplicarFiltro,
})
